import { Alert as UnstyledAlert, styled } from "@mui/material";
import type { ComponentPropsWithRef } from "react";

export interface AlertProps extends ComponentPropsWithRef<
  typeof UnstyledAlert
> {
  palette: "candidate" | "data" | "predictor" | "search-space" | "warning";
}

export const Alert = styled(UnstyledAlert, {
  shouldForwardProp: (propName: keyof AlertProps) => propName !== "palette",
})<AlertProps>(({ theme, palette }) => ({
  backgroundColor: theme.palette[palette].light,
  minHeight: theme.spacing(5),
  padding: theme.spacing(0, 2),
  alignItems: "center",
  color: theme.palette[palette].dark,

  "& .MuiAlert-message": {
    padding: theme.spacing(0.5),
  },
}));
